import React from 'react'
import { Box, Text } from '@clear/design-system'
import { AccessibleLocation } from './AccessibleLocation'

interface Availability {
  days?: string
  hours: string
}

export interface LaneInfo {
  name: string
  description: string
  isAccessible: boolean
  accessibilityMessage: string
  availability: Availability[]
  id: number
  holidayMessage?: string
}

export const LaneInfo = ({
  name,
  description,
  isAccessible,
  accessibilityMessage,
  availability,
  holidayMessage,
}: LaneInfo) => {
  return (
    <>
      <Text my={1}>{name}</Text>
      <Text>{description}</Text>
      <Box mt={1}>
        {availability.map(({ hours, days }) => (
          <div key={hours} className="mb-1">
            {days && <Text mb={2}>{days}</Text>} <Text mb={2}>{hours}</Text>
          </div>
        ))}
        {holidayMessage ? (
          <Text mb={3} color="utilityDarkErrorRed">
            {holidayMessage}
          </Text>
        ) : null}
      </Box>
      <AccessibleLocation
        isAccessible={isAccessible}
        accessibilityMessage={accessibilityMessage}
      />
    </>
  )
}
